import moment from 'moment'


/**
 *
 * @param {time} prevYearTimestamp
 * @param {time} nextYearTimestamp
 * @return {boolean}
 */
export const isSameYear = (prevYearTimestamp, nextYearTimestamp) => {
  if (!prevYearTimestamp && !nextYearTimestamp) {
    throw new Error('No timestamps provided.')
  } else if (!nextYearTimestamp || !prevYearTimestamp) {
    return false
  }

  return moment(prevYearTimestamp).isSame(nextYearTimestamp, 'year')
}

/**
 *
 * @param {time} prevMonthTimestamp
 * @param {time} nextMonthTimestamp
 * @return {boolean}
 */
export const isSameMonth = (prevMonthTimestamp, nextMonthTimestamp) => {
  if (!prevMonthTimestamp && !nextMonthTimestamp) {
    throw new Error('No timestamps provided.')
  } else if (prevMonthTimestamp && !nextMonthTimestamp || !prevMonthTimestamp && nextMonthTimestamp) {
    return false
  }

  return moment(prevMonthTimestamp).isSame(nextMonthTimestamp, 'month')
}

export const isSameMonthAndYear = (timestamp, monthTimestamp, yearTimestamp) => {
  return isSameYear(timestamp, yearTimestamp) && isSameMonth(timestamp, monthTimestamp)
}



// WEBPACK FOOTER //
// ./src/utils/momentUtils.js